export default __webpack_public_path__ + "static/alastair-e8be05f55e4c18868212615d349c76f2.jpg";